import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=04707168&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=04707168&prod&lang=scss&scoped=true"
import style1 from "./Navbar.vue?vue&type=style&index=1&id=04707168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04707168",
  null
  
)

export default component.exports